import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CreatableSelect from 'react-select/creatable';

const CustomCreatableSelect = ({
  isDisabled,
  defaultValue,
  name,
  placeholder,
  isMulti,
  id,
  options,
  onChange,
  onCreateOption,
  ...rest
}) => {
  const styles = {
    control: (base, { isFocused, }) => ({
      ...base,
      minWidth: '145px',
      width: '100%',
      borderRadius: '2px',
      border: 0,
      boxShadow: 'none',
      border: isFocused ? '1px solid #4c6072' : '1px solid #e2e5ec',
      minHeight: '38px',
      '&:hover': '1px solid #4c6072'
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? '#18af8b'
          : isFocused
          ? '#e3f5f1'
          : null,
        color: isDisabled ? '#ccc' : isSelected ? 'white' : 'black',
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled && (isSelected ? '#18af8b' : '#18af8b'),
          color: isDisabled ? '#ccc' : isFocused ? 'white' : 'black',
        },
      };
    },
    valueContainer: (styles) => {
      return {
        ...styles,
        cursor: 'pointer',
        // width: showOptionAsCheckbox && '2000px',
        color: '#4c6072'
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        margin: '5px 10px 5px 0',
      };
    },
    clearIndicator: (styles) => {
      return {
        ...styles,
        cursor: 'pointer',
      };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        cursor: 'pointer',
      };
    },
    dropdownIndicator: (styles) => {
      return {
        ...styles,
        cursor: 'pointer',
      };
    },
  };
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  return (
    <CreatableSelect
      onChange={(v) => {
        onChange(v);
      }}
      styles={styles}
      options={options}
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      isMulti={isMulti}
      id={id}
      name={name}
      placeholder={placeholder}
      onCreateOption={onCreateOption}
      controlShouldRenderValue={!menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      {...rest}
    />
  )
};

CustomCreatableSelect.propTypes = {
  isDisabled: PropTypes.bool,
  defaultValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.object,
  }),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  id: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }).isRequired
  ),
  onChange: PropTypes.func,
  onCreateOption: PropTypes.func,
};

CustomCreatableSelect.defaultProps = {
  isDisabled: false,
  defaultValue: undefined,
  name: '',
  placeholder: '',
  isMulti: false,
  id: '',
  onChange: () => {},
  onCreateOption: () => {},
};

export default CustomCreatableSelect;